<template>
    <v-card
        outlined
        class="d-flex align-center list-widget"
        v-bind="{
            width,
            height,
            minWidth,
            maxWidth,
        }"
    >
        <v-card-text class="py-0 text-caption">
            <v-row class="ma-n1" align="center">
                <v-col class="pa-1" cols="auto">
                    <span>{{ title }}:</span>
                </v-col>
                <v-col class="pa-1 list-widget__body">
                    <slot
                        v-bind="{
                            attrs: {
                                class: 'list-widget__body__input text-caption font-weight-bold',
                            },
                        }"
                    />
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: {
        title: { type: String, default: "검색결과" },
        height: { type: [Number, String], default: 40 },
        width: { type: [Number, String], default: undefined },
        minWidth: { type: [Number, String], default: undefined },
        maxWidth: { type: [Number, String], default: undefined },
    },
};
</script>

<style lang="scss" scoped>
.list-widget {
    &__body {
        ::v-deep &__input {
            .v-input__slot {
                padding: 0px !important;
            }
            input {
                text-align: end;
            }
            .v-select {
                &__selections {
                    justify-content: end;

                    & > input {
                        display: none;
                    }
                }
                &__selection {
                    margin-right: 0;
                }
            }
        }
    }
}
</style>
